import {ShiftEvent} from '@hconnect/common/types'

import {ViewMode} from '../types/viewMode.types'

export const modeAfterClose = (original?: ShiftEvent, editVersion?: ShiftEvent): ViewMode => {
  // Here we can handle the "are you sure you don't want to save"

  if (original) {
    // 'editMode'
    return {mode: 'detailsMode', itemId: original.id}
  } else if (!original && editVersion) {
    // 'createMode'
    return {mode: 'tableOnlyMode'}
  } else {
    // 'detailsMode'
    return {mode: 'tableOnlyMode'}
  }
}
